module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAGCAYAAAAL+1RLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAU0lEQVR4AV2MUQ2AMAwFW4IAHIAUUIIELCABB0hZpmASZmFT0F0/lixrcnntNa2Y2QOHDLVAhZ/FLXMhX8h+pYPciA/2LvxvgtPnlSaQES5VLS4bN6op1XD6yjoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/1.png
// module id = vaUt
// module chunks = 25